
type Props = {
  fillColor?: string,
} & typeof defaultProps;

const defaultProps = {
  fillColor: '#7E7E7E',
};
const SearchIcon = function SearchIcon(props: Props) {
  const { fillColor } = props;
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="search-icon">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4733 9.57236L12.9094 12.0427C13.2324 12.3703 13.2324 12.9162 12.9228 13.2301C12.7613 13.3939 12.546 13.4758 12.3306 13.4758C12.1153 13.4758 11.9 13.3939 11.7385 13.2301L9.30239 10.7598C8.37373 11.4558 7.21627 11.8789 5.97805 11.8789C2.89596 11.8789 0.37915 9.34034 0.37915 6.20119C0.37915 3.0757 2.8825 0.523438 5.97805 0.523438C9.06013 0.523438 11.5769 3.06205 11.5769 6.20119C11.5769 7.4705 11.1597 8.63062 10.4733 9.57236ZM5.96459 2.21585C3.79771 2.21585 2.03459 4.00379 2.03459 6.20119C2.03459 8.41224 3.79771 10.2002 5.96459 10.1865C8.13147 10.1865 9.89458 8.39859 9.89458 6.20119C9.89458 4.00379 8.13147 2.21585 5.96459 2.21585Z" fill={fillColor} />
    </svg>
  );
};
SearchIcon.defaultProps = defaultProps;
export default SearchIcon;